import { Grid } from '@material-ui/core'
import CachedIcon from '@material-ui/icons/Cached'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import ErrorIcon from '@material-ui/icons/Error'
import WarningIcon from '@material-ui/icons/Warning'
import { Labeled } from 'react-admin'
import { marigoldOrange } from 'shared/theme/colors'

import { TruckercloudIntegrationStatusEnum, TruckercloudIntegrationStatusText } from '../../models/jobs'
import { CalloutField } from '../Fields'

interface ELDIntegrationStatusProps {
  status: string
}

function getELDStatusIcon(status: string) {
  switch (status) {
    case TruckercloudIntegrationStatusEnum.NO_DATA:
      return ErrorIcon
    case TruckercloudIntegrationStatusEnum.DATA_AVAILABLE:
      return CachedIcon
    case TruckercloudIntegrationStatusEnum.VERIFIED:
      return CheckCircleIcon
    case TruckercloudIntegrationStatusEnum.NEEDS_VERIFICATION:
      return WarningIcon
    default:
      return ErrorIcon
  }
}

function getELDStatusIconColor(status: string) {
  switch (status) {
    case TruckercloudIntegrationStatusEnum.NO_DATA:
      return marigoldOrange
    case TruckercloudIntegrationStatusEnum.DATA_AVAILABLE:
      return 'gray'
    case TruckercloudIntegrationStatusEnum.VERIFIED:
      return 'green'
    case TruckercloudIntegrationStatusEnum.NEEDS_VERIFICATION:
      return 'crimson'
    default:
      return marigoldOrange
  }
}

export const ELDIntegrationField = (props: ELDIntegrationStatusProps) => {
  const status = props.status
  return (
    <Grid item>
      <Labeled label="Truckercloud Status">
        <CalloutField
          icon={getELDStatusIcon(status)}
          iconProps={{ style: { color: getELDStatusIconColor(status), fontSize: 'medium' } }}
          label={TruckercloudIntegrationStatusText[status]}
          labelVariant="body2"
        />
      </Labeled>
    </Grid>
  )
}
